// Airline facts verified on the airline's official website. Empty until the verification table is approved.
// Shape: { 'air-france': { facts: [{ label, value, sourceUrl, verifiedOn: 'DD/MM/YYYY' }] } }
export const verifiedAirlineFacts = {};
